let check = document.querySelector('.toggle-mega-drawer');
let newMegaMenu = document.querySelector('.new-mega-menu');

if(!check) return;



function checkActiveDrawers(drawerId, back) {
  let activeDrawers = document.querySelectorAll('.drawer-active');

  if(activeDrawers.length == 0) {
    document.querySelectorAll('.menu-drawer__menu--without-submenu > .menu-drawer__menu-item')
  .forEach(item => item.classList.remove('temp-hidden'));
  document.querySelectorAll(`.mega-menu-drawer .menu-drawer__menu-item`).forEach(item => item.classList.remove('temp-hidden'));
  } else {
    document.querySelectorAll('.menu-drawer__menu--without-submenu > .menu-drawer__menu-item')
    .forEach(item => item.classList.add('temp-hidden'));

    document.querySelectorAll(`.mega-menu-drawer:not(#${drawerId}) > .menu-drawer__menu-item, .mega-menu-drawer:not(#${drawerId}) > .toggle-mega-drawer__link-back`).forEach(item => item.classList.add('temp-hidden'));
    document.querySelectorAll(`.mega-menu-drawer#${drawerId} > .menu-drawer__menu-item, .mega-menu-drawer#${drawerId} > .toggle-mega-drawer__link-back`).forEach(item => item.classList.remove('temp-hidden'));
    if (back) {
      let tempDrawerId = drawerId.replace(/-[^-]*$/, '');    
      document.querySelectorAll(`.mega-menu-drawer#${tempDrawerId} > .menu-drawer__menu-item, .mega-menu-drawer#${tempDrawerId} > .toggle-mega-drawer__link-back`).forEach(item => item.classList.remove('temp-hidden'));      
    }
  } 

}

document.addEventListener('click', function (e) {
    let target = e.target;
    let back = false;
    if (target.classList.contains('toggle-mega-drawer')) {
      let drawerId = target.dataset.drawerId;
      document.querySelector(`#${drawerId}`).classList.toggle('drawer-active');

      if (target.classList.contains('toggle-mega-drawer__link-back')) {
        back = true
      }
      checkActiveDrawers(drawerId, back);
    }
});

if(!newMegaMenu) {

  document.querySelectorAll('header-menu [id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('mouseenter', (event) => {
      event.target.setAttribute('aria-expanded', !event.target.closest('details').hasAttribute('open'));
      event.target.closest('details').setAttribute('open', 'open');
    });

    summary.closest('.mega-menu').addEventListener('mouseleave', (event) => {
      event.target.closest('details').removeAttribute('open');
    });

  });
} else {
    document.querySelectorAll('ul.list-menu li').forEach((summary)=>{
      const allSiblings = document.querySelectorAll('[id^="MegaMenu-Content-"]');
      const stickyHeader = document.querySelector('sticky-header');
      summary.addEventListener("mouseenter", (event)=>{
        if (summary.querySelector('[id^="Details-HeaderMenu-"]')) {
          const siblingIdArray = (summary.querySelector('[id^="Details-HeaderMenu-"]').id);
          const siblingId = "MegaMenu-Content-"+siblingIdArray[siblingIdArray.length - 1];
          allSiblings.forEach(element => {
            element.style.display = 'none';
          });
          document.getElementById(siblingId).style.display = "flex";
          stickyHeader.classList.remove('floating-header');
        }else{
          allSiblings.forEach(element => {
            element.style.display = 'none';
          });
          stickyHeader.classList.add('floating-header');
        }
      });
      summary.closest(".header-wrapper").addEventListener("mouseleave", (event)=>{
        stickyHeader.classList.add('floating-header');
        allSiblings.forEach(element => {
          element.style.display = 'none';
        });
        stickyHeader.classList.add('floating-header');
      });
    });

    document.getElementById('cart-icon-bubble-new').addEventListener("click", function(e) {
      e.preventDefault();
      document.getElementById('cart-icon-bubble').click();
    });

}




